const moduleSelector = '.video-banner';

function getYouTubeId(url) {
  if (!url) return null;
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([^?&/]+)/,
  );
  return match ? match[1] : null;
}

function createModal() {
  const modal = document.createElement('div');
  modal.className = 'video-banner-modal';
  modal.innerHTML = /* html */ `
    <div class="video-banner-modal__overlay"></div>
    <div class="video-banner-modal__content">
      <button class="video-banner-modal__close" aria-label="Close">&times;</button>
      <iframe src="" frameborder="0" allowfullscreen allow="autoplay; encrypted-media"></iframe>
    </div>
  `;
  document.body.appendChild(modal);

  const overlay = modal.querySelector('.video-banner-modal__overlay');
  const closeBtn = modal.querySelector('.video-banner-modal__close');
  const iframe = modal.querySelector('iframe');

  function close() {
    modal.classList.remove('video-banner-modal--active');
    iframe.src = '';
  }

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  return { modal, iframe };
}

(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  const { modal, iframe } = createModal();

  modules.forEach((section) => {
    const videoUrl = section.dataset.video;
    const videoId = getYouTubeId(videoUrl);
    if (!videoId) return;

    const playBtn = section.querySelector('.video-banner__play');
    if (!playBtn) return;

    playBtn.addEventListener('click', () => {
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      modal.classList.add('video-banner-modal--active');
    });
  });
})();
